const items = ["Cristian Díaz", "El Cacique", "Colo-Colo N°42", "Volante Central", "Mundialista Sub-17", "Qatar 2025", "La Roja Sub-17"];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <div data-testid="editorial-marquee" className="relative border-y border-neutral-800 bg-[#0a0a0a] py-5 overflow-hidden">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {row.map((t, i) => (
          <span key={i} className="flex items-center font-display text-2xl sm:text-3xl font-extrabold uppercase italic tracking-wide text-neutral-200">
            <span className="px-6">{t}</span>
            <svg width="14" height="14" viewBox="0 0 24 24" className="fill-[#d4af37] shrink-0">
              <path d="M12 2l2.4 4.9 5.4.8-3.9 3.8.9 5.4L12 14.3 7.2 16.9l.9-5.4L4.2 7.7l5.4-.8z" />
            </svg>
          </span>
        ))}
      </div>
    </div>
  );
}
